import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, tap, delay } from 'rxjs/operators';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import { RemoveArchiveAssets, UploadAssets } from '@apps/clos-sessions/state/archive-assets';
import { SetArchivePrice, SyncArchive } from '@apps/clos-sessions/state/archives';

@Injectable()
export class SyncArchiveEffect implements OnDestroy {
  protected destroy$ = new Subject<void>();

  constructor(
    protected actions$: Actions,
    protected store: Store,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  use(): void {
    this.actions$
      .pipe(
        ofActionSuccessful(RemoveArchiveAssets, UploadAssets, SetArchivePrice),
        // techdebt https://github.com/CLOS-Inc/CLOS_Frontend/issues/573
        delay(3000),
        tap((action: RemoveArchiveAssets | UploadAssets | SetArchivePrice) => {
          this.store.dispatch(new SyncArchive({ archive: action.payload.archive }));
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }
}
